// Importations nécessaires
import $ from 'jquery';
import {TimelineLite} from 'gsap';
import mobile from '../utils/mobile';
import search from '../utils/search';

import product from '../pages/product';

// Module Menu
const menu = {
	hideLOGO: false,
	OPEN: false,
	name: "",
	anchor: "",
	show_logoTM: new TimelineLite(),
	animMENU: new TimelineLite(),
	LOADED: false,
	search: false,

	init() {
		//////////////////////////////////////
		// FERMETURE MODALS
		$(window).on("blur", () => {
			this.closeSub();
		});

		$(window).on("click", (event) => {
			if (!event.target.matches('.__module_search, .__module_search *, .__search_module, .__search_module *, ._desktop, ._desktop *')) {
				this.closeSub();
			}
		});

		//////////////////////////////////////
		// MODAL
		$(document).on("click", "._close_modal,._background_modal", () => {
			this.closeAllModals();
		});

		// Fermeture au clavier (Echap) - aucune modal du site ne le gerait
		// jusqu'ici (bouton Close / clic sur l'overlay uniquement).
		$(document).on("keydown", (e) => {
			if (e.key === "Escape") {
				this.closeAllModals();
			}
		});

		//////////////////////////////////////
		// MODAL TRUST (footer)
		$(document).on("click", "[data-trust-open]", (e) => {
			const id = $(e.currentTarget).data("trust-open");
			$(`.--modal-trust[data-trust-modal="${id}"]`).addClass("_show");
			$("html,body").addClass("_overflow");
		});

		//////////////////////////////////////
		// ACCORDION FAQ (liste question/reponse compacte, un seul ouvert a la fois)
		$(document).on("click", ".__ul_faq.--accordion > li", function () {
			$(this).siblings().removeClass("_open").find(".__answer").slideUp();
			$(this).toggleClass("_open").find(".__answer").slideToggle();
		});

		// ACCORDION FAQ PAR CATEGORIE (chaque groupe reste independant)
		$(document).on("click", ".__faq_category_toggle", function () {
			const $category = $(this).closest(".__block_faq");
			const shouldOpen = !$category.hasClass("_open");

			$category.toggleClass("_open", shouldOpen);
			$(this).attr("aria-expanded", String(shouldOpen));
			$category.children(".__faq_category_panel").stop(true, true).slideToggle(260);
		});

		// "Collapse all" / "Open all" - categories FAQ fermees par defaut (cf.
		// ophorus_site_faq.php, plus de classe "_open" sur ".__block_faq" au
		// chargement), meme principe que ".__partners_toggle_all" plus bas.
		// Libelle du bouton mis a jour seulement une fois l'animation
		// terminee (etait immediat, en meme temps que la classe "_open") :
		// pendant les 260ms de "slideToggle", le libelle annoncait deja
		// l'etat final alors que les panneaux etaient encore visuellement a
		// mi-chemin - lisible comme "le bouton indique l'inverse de ce qui
		// est affiche" - cf. retours utilisateur.
		$(document).on("click", ".__faq_toggle_all", function () {
			const $btn = $(this);
			const $categories = $(".__block_faq");
			const expand = $btn.attr("data-state") !== "expanded";

			$categories.each(function () {
				const $category = $(this);
				if ($category.hasClass("_open") !== expand) {
					$category.toggleClass("_open", expand);
					$category.find(".__faq_category_toggle").attr("aria-expanded", String(expand));
					$category.children(".__faq_category_panel").stop(true, true).slideToggle(260);
				}
			});

			setTimeout(() => {
				$btn.attr("data-state", expand ? "expanded" : "collapsed");
				$btn.find("span").text(expand ? "Collapse all" : "Open all");
			}, 260);
		});

		// ACCORDION PARTENAIRES PAR CATEGORIE (chaque groupe reste independant)
		$(document).on("click", ".__partners_cat_toggle", function () {
			const $category = $(this).closest(".__block_partners_cat");
			const shouldOpen = !$category.hasClass("_open");

			$category.toggleClass("_open", shouldOpen);
			$(this).attr("aria-expanded", String(shouldOpen));
			$category.children(".__partners_cat_panel").stop(true, true).slideToggle(260);
		});

		// "Collapse all" / "Open all" - meme principe que
		// ".__informations_toggle_all" (product.js), adapte ici aux categories
		// partenaires qui ne sont pas des <details> natifs mais des blocs
		// ".__block_partners_cat._open" pilotes par slideToggle ci-dessus.
		$(document).on("click", ".__partners_toggle_all", function () {
			const $btn = $(this);
			const $categories = $(".__block_partners_cat");
			const expand = $btn.attr("data-state") !== "expanded";

			$categories.each(function () {
				const $category = $(this);
				if ($category.hasClass("_open") !== expand) {
					$category.toggleClass("_open", expand);
					$category.find(".__partners_cat_toggle").attr("aria-expanded", String(expand));
					$category.children(".__partners_cat_panel").stop(true, true).slideToggle(260);
				}
			});

			$btn.attr("data-state", expand ? "expanded" : "collapsed");
			$btn.find("span").text(expand ? "Collapse all" : "Open all");
		});

		//////////////////////////////////////
		// ACCORDION REGIONS (menu mobile destinations/shore)
		$(document).on("click", "._region_toggle", (e) => {
			$(e.currentTarget).closest("._region_accordion").toggleClass("_open");
		});

		//////////////////////////////////////
		// ACCORDION FOOTER (mobile uniquement, cf. _footer.scss
		// ".__footer_col_toggle" - sans effet visuel sur desktop, le ss_ul
		// reste toujours affiche via le CSS non scope au breakpoint mobile).
		// "closest('li').find('.ss_ul')" (etait "$title.next('.ss_ul')") :
		// la colonne Help & Resources peut contenir 2 listes ss_ul (FAQ/
		// Contact puis Brochures, cf. footer_content.php) - .next() ne
		// basculait que la premiere, laissant Brochures invisible et
		// inaccessible sur mobile.
		$(document).on("click", ".__footer_col_toggle", (e) => {
			const $title = $(e.currentTarget);
			const $list = $title.closest("li").find(".ss_ul");
			const willOpen = !$title.hasClass("_open");

			$title.toggleClass("_open", willOpen);
			$list.stop(true, true).slideToggle(220);
		});

		const setupFooterRichLinks = () => {
			$("._bottom_desc .__content table td").each((index, cell) => {
				const $cell = $(cell);
				if ($cell.data("footer-rich-ready")) {
					return;
				}

				const $title = $cell.find("strong, b, h3, h4, h5, h6").first();
				if (!$title.length) {
					return;
				}

				const $titleBlock = $title.closest("p, h3, h4, h5, h6");
				const $titleSource = $titleBlock.length ? $titleBlock : $title;
				const title = $.trim($title.text());
				const panelId = `footer-rich-panel-${index}`;
				const $panel = $(`<div class="__footer_rich_panel" id="${panelId}"></div>`);
				const $toggle = $(`
					<button type="button" class="__footer_rich_toggle" aria-expanded="false" aria-controls="${panelId}">
						<span></span>
						<span class="__footer_rich_toggle_icon" aria-hidden="true"></span>
					</button>
				`);

				$toggle.find("span").first().text(title);
				const $panelContent = $titleSource.nextAll();

				$cell.addClass("__footer_rich_group").data("footer-rich-ready", true);
				$titleSource.addClass("__footer_rich_title").before($toggle).after($panel);
				$panel.append($panelContent);
			});
		};

		setupFooterRichLinks();

		$(document).on("click", ".__footer_rich_toggle", (e) => {
			const $toggle = $(e.currentTarget);
			const $group = $toggle.closest(".__footer_rich_group");
			const $panel = $group.children(".__footer_rich_panel");
			const willOpen = !$group.hasClass("_open");

			$toggle.toggleClass("_open", willOpen).attr("aria-expanded", String(willOpen));

			if (willOpen) {
				$panel.hide();
				$group.addClass("_open");
				$panel.stop(true, true).slideDown(220);
				return;
			}

			$panel.stop(true, true).slideUp(220, () => {
				$group.removeClass("_open");
			});
		});

		//////////////////////////////////////
		// ONGLETS FOOTER (Day trips / Popular destinations / Popular
		// categories, cf. _footer.scss ".__footer_tabs") - un seul panneau
		// visible a la fois, meme composant que le footer Airbnb pris en
		// reference.
		$(document).on("click", ".__footer_tab_btn", (e) => {
			const $btn = $(e.currentTarget);
			const tab = $btn.data("footer-tab");
			const $tabs = $btn.closest(".__footer_tabs");

			$tabs.find(".__footer_tab_btn").removeClass("_active");
			$btn.addClass("_active");

			$tabs.find(".__footer_tab_panel").removeClass("_active");
			$tabs.find(`.__footer_tab_panel[data-footer-panel="${tab}"]`).addClass("_active");
		});

		//////////////////////////////////////
		// ONGLETS FOOTER - defilement type "swiper" (glisse au doigt +
		// fleches prev/next) quand la liste d'onglets deborde de sa largeur,
		// meme principe que sur GetYourGuide - cf. retours utilisateur.
		const updateFooterTabsNav = ($wrap) => {
			const $nav = $wrap.find(".__footer_tabs_nav");
			const $controls = $wrap.find(".__footer_tabs_nav_controls");
			const nav = $nav.get(0);
			if (!nav) return;

			const overflowing = nav.scrollWidth > nav.clientWidth + 1;
			$controls.toggleClass("_show", overflowing);

			const $prev = $controls.find(".--prev");
			const $next = $controls.find(".--next");
			$prev.prop("disabled", nav.scrollLeft <= 0);
			$next.prop("disabled", nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 1);
		};

		$(".__footer_tabs_nav_wrap").each((i, el) => updateFooterTabsNav($(el)));

		$(window).on("resize", () => {
			$(".__footer_tabs_nav_wrap").each((i, el) => updateFooterTabsNav($(el)));
		});

		$(document).on("scroll", ".__footer_tabs_nav", (e) => {
			updateFooterTabsNav($(e.currentTarget).closest(".__footer_tabs_nav_wrap"));
		});

		$(document).on("click", ".__footer_tabs_nav_arrow", (e) => {
			const $btn = $(e.currentTarget);
			if ($btn.prop("disabled")) return;

			const $wrap = $btn.closest(".__footer_tabs_nav_wrap");
			const nav = $wrap.find(".__footer_tabs_nav").get(0);
			if (!nav) return;

			const amount = nav.clientWidth * .7 * ($btn.hasClass("--next") ? 1 : -1);
			nav.scrollBy({left: amount, behavior: "smooth"});
		});

		//////////////////////////////////////
		// RECHERCHE VILLE (menu mobile destinations)
		$(document).on("input", "._dest_search_input", (e) => {
			const query = $(e.currentTarget).val().trim().toLowerCase();
			const $items = $("#_mobile_dest_list ._contain_dest");
			let visibleCount = 0;

			$items.each((i, el) => {
				const $el = $(el);
				const match = !query || (($el.data("search") || "").toString().indexOf(query) !== -1);
				$el.toggle(match);
				if (match) {
					visibleCount++;
					$el.toggleClass("_open", !!query);
				} else {
					$el.removeClass("_open");
				}
			});

			$("#_mobile_dest_list").siblings("._dest_no_result").toggleClass("_show", visibleCount === 0);
		});

		$(document).on("input", "._shore_search_input", (e) => {
			const normalize = (value) => value
				.toString()
				.normalize("NFD")
				.replace(/[\u0300-\u036f]/g, "")
				.toLowerCase();
			const query = normalize($(e.currentTarget).val().trim());
			const $items = $("#_mobile_shore_list ._contain_dest");
			let visibleCount = 0;

			$items.each((i, el) => {
				const $el = $(el);
				const match = !query || normalize($el.data("search") || $el.text()).indexOf(query) !== -1;
				$el.toggle(match);
				$el.toggleClass("_open", match && !!query);
				if (match) {
					visibleCount++;
				}
			});

			$("._shore_no_result").toggleClass("_show", visibleCount === 0);
		});

		$(document).on("input", ".__dest_menu_search_input", (e) => {
			const normalize = (value) => value
				.toString()
				.normalize("NFD")
				.replace(/[\u0300-\u036f]/g, "")
				.toLowerCase();
			const query = normalize($(e.currentTarget).val().trim());
			const $menu = $(e.currentTarget).closest(".__contain_ss");
			const $items = $menu.find(".__dest_menu_item");
			let visibleCount = 0;

			$items.each((i, el) => {
				const $el = $(el);
				const regionMatch = !query || normalize($el.data("region") || "").indexOf(query) !== -1;
				let cityMatch = false;

				$el.find("> ul > li").each((cityIndex, cityEl) => {
					const $city = $(cityEl);
					const match = !query || regionMatch || normalize($city.data("search") || $city.text()).indexOf(query) !== -1;
					$city.toggle(match);
					if (match && query && !regionMatch) {
						cityMatch = true;
					}
				});

				const match = !query || regionMatch || cityMatch || normalize($el.data("search") || "").indexOf(query) !== -1;
				$el.toggle(match);
				if (match) {
					visibleCount++;
				}
			});

			$menu.find(".__dest_menu_empty").toggleClass("_show", visibleCount === 0);
		});

		//////////////////////////////////////////////////////////////////////
		//  MOBILE MENU
		/////////////////////////////////////////////////////////////////////
		$(document).on("click", "._ham_mobile", () => {
			this.toggleMENU();
		});

		$(document).on("click", "._search", () => {
			// Sur mobile, l'icone recherche ouvre directement la modal complete
			// (destination + suggestions + date + participants, cf.
			// site/TEMPLATES/modals.php #modal_search_destination) plutot que
			// la barre simple ".__module_search" (2 champs qui renvoyaient
			// eux-memes vers des sous-modals separees).
			if (mobile.state) {
				search.openDestinationModal("_mobile_bar");
				return;
			}
			$(".__module_search").toggleClass("_open_search");
			$("._search").toggleClass("_cancel_search");
		});

		$(document).on("click", ".__mobile_menu_search", () => {
			this.toggleMENU();
			search.openDestinationModal("_mobile_bar");
		});

		$(document).on("click", "._cancel_search", () => {
			$(".__module_search").removeClass("_open_search");
			$("._search").removeClass("_cancel_search");
		});

		$(document).on("click", ".__ss_menus_mobile > .__menus > ul > li", function () {
			const menuData = $(this).data("menu");
			if (menuData) {
				menu.showMOBILEssMENU(menuData);
			}
		});

		$(document).on("click", "._back_ss_menu", () => {
			this.closeMOBILEssMENU();
		});

		//////////////////////////////////////////////////////////////////////
		//  SCROLL EVENTS
		/////////////////////////////////////////////////////////////////////
		$(window).on("scroll", () => {
			this.onScroll();
		});

		// SOUS MENU
		$(document).on("mouseover", "nav > ul > li[data-ss] > span", function () {
			const _id = $(this).parent().data("ss");
			$(".--ss_menu").show();//css("display", "block");
			$(".__header").addClass("__open_sub");
			$(".__contain_ss").hide();//css("display", "none");
			$(".__contain_ss[data-ss=" + _id + "]").show();//css("display", "block");
		});

		$(document).on("mouseleave", ".--ss_menu", (e) => this.onMouseOut(e));

		$(document).on("click", "._mobile_menu_level_p", function () {
			if ($(this).hasClass("_opened")) {
				$("._mobile_menu_level_p").removeClass("_opened");
				$(".ss_menu").hide();//css("display", "none");
			} else {
				$("._mobile_menu_level_p").removeClass("_opened");
				$(this).addClass("_opened");
				$(".ss_menu").css("display", "none");
				$(this).next(".ss_menu").css("display", "block");
			}
		});

		$(document).on("click", "._mobile_menu_level_p_2", function () {
			if ($(this).hasClass("_opened")) {
				$("._mobile_menu_level_p_2").removeClass("_opened");
				$(".ss_ssmenu").css("display", "none");
			} else {
				$("._mobile_menu_level_p_2").removeClass("_opened");
				$(this).addClass("_opened");
				$(".ss_ssmenu").css("display", "none");
				$(this).next(".ss_ssmenu").css("display", "block");
			}
		});
	},

	closeSub() {
		if (!mobile.state) {
			this.search = false;
			$(".__header").removeClass("__open_sub __open_modal");
			$(".--ss_menu, .__contain_ss").hide();
			$(".__module_search").removeClass("_open_search");
		}
	},

	// Fermeture partagee par le clic sur "Close"/l'overlay et la touche Echap
	// (cf. init() ci-dessus) - une seule modal a la fois est jamais ouverte
	// donc cibler toutes les ".__modal" sans distinction est sans risque.
	closeAllModals() {
		$(".__modal").removeClass("_show");
		$("html,body").css("overflow", "auto").removeClass("_overflow");
	},

	toggleMENU() {
		const container = $("._contain_ss_menus");

		if (container.hasClass("_open")) {
			container.addClass("_close");
		} else {
			container.removeClass("_close");
			mobile.closeBasket();
		}

		$(".__header").toggleClass("_open_mobile");
		$(".ham").toggleClass("active");
		container.toggleClass("_open");
		$("html,body").toggleClass("_overflow");
	},

	showMOBILEssMENU(menuData) {
		$(".__mobile_ss_menus[data-menu!=" + menuData + "]").removeClass("_show_ss");
		$(".__mobile_ss_menus[data-menu=" + menuData + "]").addClass("_show_ss");
		$("._contain_ss_menus").addClass("_show_ss");
	},

	closeMOBILEssMENU() {
		$(".__mobile_ss_menus").removeClass("_show_ss");
		$("._contain_ss_menus").removeClass("_show_ss");
	},

	onScroll() {
		this.closeSub();

		const scrollTop = $(window).scrollTop();
		if (!mobile.state) {
			if (scrollTop > 100) {
				$("header").addClass("__move_header");
			} else {
				$("header").removeClass("__move_header");
			}


			//  ///////////////////////////////////////////////////////
			//
			//  SPECIFIC PRODUIT
			//
			//  ////////////////////////////////////////////////////////
			if (product.activ === true) {
				const $booking = $(".__booking");

				// position documentaire naturelle de .__booking (position:relative
				// de base), capturee une seule fois avant tout passage en fixed :
				// sert de repere pour recalculer le "top" de la sidebar quand elle
				// se fige (repasse en absolute) au-dessus des reviews.
				if (this.bookingAnchorTop === undefined && $booking.length
					&& !$booking.hasClass("__fixed") && !$booking.hasClass("__stopped")) {
					this.bookingAnchorTop = $booking.offset().top;
				}

				if (scrollTop > (product.header_height - 80)) {
					$(".__product_nav,.__ophorus_product").addClass("__fixed");

					// Package : pas de calendrier/formulaire de reservation donc
					// scanValidity/moduleContact ne passent jamais a true - la
					// sidebar (liste d'options) doit juste rester sticky des que
					// l'on scrolle, sans la logique de validite/collapse du
					// vrai formulaire de reservation produit.
					if ($(".__ophorus_package").length > 0) {
						$booking.addClass("__fixed");
					} else if ($booking.hasClass("__bottom_open") === false) {
						if (product.scanValidity === true || product.moduleContact === true) {
							if (product.valid === true || product.moduleContact === true) {
								if ($booking.hasClass("__block_open") === false) {
									$booking.addClass("__fixed __product_valid __show_bottom");
									$(".--show_contain").removeClass("__force_open");
									$(".--contain_options").slideUp(100);
								} else {
									$booking.addClass("__fixed");
								}
							} else {
								$booking.addClass("__fixed");
							}
						}
					}
					this.updateBookingStop(scrollTop);
				} else {
					$(".__product_nav,.__ophorus_product").removeClass("__fixed");
					$(".__booking, ._contain_all").removeClass("__fixed __stopped __show_bottom __bottom_open __force_open").css("top", "");
					$(".--show_contain").removeClass("__force_open");
					if (product.scanValidity === true) {
						if (product.valid === true) {
							$(".--contain_options").slideDown(100);
						}
					}
				}

			}
		}
	},

	// Au-dela des sections "reduites" (description/informations...), reviews
	// et faq passent en conteneur "_full" (largeur augmentee, cf.
	// sass/SITE/common/_common_sections.scss) et ne reservent donc plus de
	// gouttiere pour la sidebar : la garder en position:fixed jusque-la la
	// ferait flotter par-dessus ce contenu. Des qu'elle approcherait le haut
	// de la section reviews, on la fige (repasse en absolute, .__booking
	// redevient "position:relative" et c'est ._contain_all qui recoit un
	// "top" calcule en inline par le JS) au lieu de continuer a suivre le
	// scroll par-dessus : elle reste alors visible, figee, et scrolle
	// normalement avec la page (comme sur Get Your Guide). En remontant, des
	// qu'on repasse sous ce seuil elle redevient fixed/sticky.
	updateBookingStop(scrollTop) {
		const $booking = $(".__booking");
		const $sidebar = $("._contain_all");
		// Cale sur le premier contenu de la colonne d'avis - la barre
		// recherche/vue (".__reviews_toolbar") si presente, sinon la grille
		// de fiches elle-meme (".__all_reviews") -, pas sur le haut de toute
		// la section (qui inclut le padding, le titre "Reviews", la note
		// globale et les filtres) : la sidebar se fige donc bien plus bas,
		// au niveau de ce premier contenu plutot que plaquee sous le nav.
		// Un produit (ou package) sans avis n'affiche pas la section reviews
		// du tout (cf. product_reviews.php, tout est conditionne a
		// !empty($reviews)) : sans repere, la sidebar resterait fixed a
		// l'infini par-dessus le reste de la page. Les sections qui la
		// precedent (Informations, Meeting point...) gardent un "container"
		// normal (gouttiere reservee pour la sidebar), donc rien n'oblige a
		// s'arreter avant elles - seule la prochaine section en "container
		// _full" compte. On retombe donc sur FAQ (.__product_faq, "Quick
		// answers") puis, a defaut, sur les suggestions
		// (.__product_suggestions), toutes deux egalement conditionnees a du
		// contenu non vide mais l'une des deux est quasi toujours presente.
		const $reviews = $(".__reviews_toolbar").first().length ? $(".__reviews_toolbar").first()
			: $(".__all_reviews").first().length ? $(".__all_reviews").first()
			: $(".__product_reviews").first().length ? $(".__product_reviews").first()
			: $(".__product_faq").first().length ? $(".__product_faq").first()
			: $(".__product_suggestions").first();
		if (!$reviews.length || !$sidebar.length || this.bookingAnchorTop === undefined) {
			return;
		}

		const topOffset = 130; // valeur de .__booking.__fixed { top: 130px; }
		const margin = 30;
		const reviewsTop = $reviews.offset().top;
		const sidebarHeight = $sidebar.outerHeight();
		const stopScrollY = reviewsTop - sidebarHeight - margin - topOffset;

		if (scrollTop >= stopScrollY) {
			const desiredDocumentTop = reviewsTop - sidebarHeight - margin;
			$booking.removeClass("__fixed").addClass("__stopped");
			$sidebar.css("top", `${desiredDocumentTop - this.bookingAnchorTop}px`);
		} else if ($booking.hasClass("__stopped")) {
			$booking.removeClass("__stopped").addClass("__fixed");
			$sidebar.css("top", "");
		}
	},

	onMouseOut(event) {
		const e = event.toElement || event.relatedTarget;
		if (e === null || !(e.parentNode == this || e == this || e.className == "_contain")) {
			this.closeSub();
		}
	}
};


export default menu;
